import { render, staticRenderFns } from "./Veiculos.vue?vue&type=template&id=8bb0f14c&scoped=true"
import script from "./Veiculos.vue?vue&type=script&lang=js"
export * from "./Veiculos.vue?vue&type=script&lang=js"
import style0 from "./Veiculos.vue?vue&type=style&index=0&id=8bb0f14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb0f14c",
  null
  
)

export default component.exports